import React from 'react';
import { ShieldCheck, ShieldAlert, Eye, ClipboardX, Clock } from 'lucide-react';
import { HiddenBadge } from './ReportBits';

const RISK = { Low: 'bg-emerald-50 text-emerald-700 border-emerald-200', Medium: 'bg-amber-50 text-amber-700 border-amber-200', High: 'bg-red-50 text-red-700 border-red-200' };

export const IntegrityPanel = ({ integrity, submitMode, hidden }) => {
  const Icon = integrity.risk === 'Low' ? ShieldCheck : ShieldAlert;
  const used = integrity.time_used_seconds || 0;
  const rows = [
    { icon: Eye, label: 'Window / tab switches', value: integrity.tab_switches },
    { icon: ClipboardX, label: 'Blocked outside pastes', value: integrity.paste_blocked },
    { icon: Clock, label: 'Time away from test', value: `${integrity.away_seconds}s` },
    { icon: Clock, label: 'Time used', value: `${Math.floor(used / 60)}m ${String(used % 60).padStart(2, '0')}s / ${Math.round((integrity.duration_seconds || 1200) / 60)}m` },
  ];
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="report-integrity-panel">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>Integrity</h3>
          {hidden && <HiddenBadge testid="hidden-badge-integrity" />}
        </div>
        <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${RISK[integrity.risk]}`} data-testid="report-integrity-risk">
          <Icon className="h-3.5 w-3.5" /> {integrity.risk} risk · {integrity.integrity_score}/100
        </span>
      </div>
      <div className="space-y-2.5">
        {rows.map(({ icon: I, label, value }) => (
          <div key={label} className="flex items-center justify-between text-sm">
            <span className="flex items-center gap-2 text-slate-600"><I className="h-4 w-4 text-slate-400" /> {label}</span>
            <span className="font-semibold text-slate-900">{value}</span>
          </div>
        ))}
        <p className="text-[11px] text-slate-400 pt-1">Submission: {submitMode === 'timeout' ? 'auto-submitted when time ran out' : submitMode === 'late' ? 'late (last autosave used)' : 'submitted by candidate'}</p>
      </div>
    </section>
  );
};

export default IntegrityPanel;
